import React from "react";
import { Link } from "react-router-dom";

import MainLogo from "../../assets/images/main-logo-blue.png";

function Error404Page() {
    return (
        <div>
            <section className="content-section">
                <div className="container">
                    <div className="error-wrap">
                        <img src={MainLogo} alt="404LOGO" />
                        <h2>喵的... 出現404了!!!</h2>
                        <p>網址好像錯了唷</p>
                        <p>
                            <Link to="/">點我回首頁</Link>
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Error404Page;
